import React from 'react';
import {
  OnboardingWelcomeModal,
  SetupBrokerageWizardModal,
  OnboardingPreLaunchModal,
  UserSuggestedUpdateModal,
  FeedbackModal,
  AppointmentActionModal,
  ContextualChatModal,
  AddListingToTourModal,
} from 'modals';
import { useDialogStore } from 'hooks/dialogStore/useDialogStore';
import { LEGACY_DIALOG_KEYS } from 'modals/keys';

export default () => {
  const { isUsingNewArchitecture } = useDialogStore();

  const feedbackUsingNewArch = isUsingNewArchitecture(
    LEGACY_DIALOG_KEYS.FeedbackModal,
  );

  const appointmentUsingNewArch = isUsingNewArchitecture(
    LEGACY_DIALOG_KEYS.FeedbackModal,
  );

  const chatUsingNewArch = isUsingNewArchitecture(
    LEGACY_DIALOG_KEYS.ContextualChatModal,
  );

  const listingUsingNewArch = isUsingNewArchitecture(
    LEGACY_DIALOG_KEYS.AddListingToTourModal,
  );

  const suggestedUpdateUsingNewArch = isUsingNewArchitecture(
    LEGACY_DIALOG_KEYS.UserSuggestedUpdateModal,
  );

  const onboardingWelcomeUsingNewArch = isUsingNewArchitecture(
    LEGACY_DIALOG_KEYS.OnboardingWelcomeModal,
  );

  const onboardingPreUpdateUsingNewArch = isUsingNewArchitecture(
    LEGACY_DIALOG_KEYS.OnboardingPreLaunchModal,
  );

  const setupBrokerageUsingNewArch = isUsingNewArchitecture(
    LEGACY_DIALOG_KEYS.SetupBrokerageWizardModal,
  );

  return (
    <>
      {listingUsingNewArch ? null : <AddListingToTourModal />}
      {setupBrokerageUsingNewArch ? null : <SetupBrokerageWizardModal />}
      {onboardingWelcomeUsingNewArch ? null : <OnboardingWelcomeModal />}
      {onboardingPreUpdateUsingNewArch ? null : <OnboardingPreLaunchModal />}
      {suggestedUpdateUsingNewArch ? null : <UserSuggestedUpdateModal />}
      {feedbackUsingNewArch ? null : <FeedbackModal />}
      {appointmentUsingNewArch ? null : <AppointmentActionModal />}
      {chatUsingNewArch ? null : <ContextualChatModal />}
    </>
  );
};
